import { render, staticRenderFns } from "./ByDocumentsComponent.vue?vue&type=template&id=fd2d40d6"
import script from "./ByDocumentsComponent.vue?vue&type=script&lang=ts"
export * from "./ByDocumentsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports